import {sleep, useMock} from "../utils/helpers";

class Auth {

  constructor() {
    this.useMock = useMock('ui');
  }

  async fetchDashboard(userId) {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(500);
        resolve((await import('../../mock/auth.js')).getDashboard(userId));
      });
    }
  }

}

export default new Auth();



// WEBPACK FOOTER //
// ./src/services/ui.js